// What this screen is doing, as opposed to what the game is doing. Survives every snapshot swap.
import { G } from '../sim/game.js';

export const UI = {
  seat: 0,            // which player this screen is
  mode: 'title',      // 'title' | 'solo' | 'online'
  hover: null, drag: null, bend: null, unhook: null, carry: null, hoverMap: null, hoverChip: null, colourBlind: false, placing: null, selLine: null, mouse: null, cam: null,
  watching: false, fx: [], pops: [], rushWarned: false, demo: false,
};
export const me = () => (G && G.players ? G.players[UI.seat] : null);
export const myClaim = () => (G && G.seats && G.seats[UI.seat] ? G.seats[UI.seat].claim : null);
export const selLine = () => { const p = me(); return p && UI.selLine != null ? p.lines.find(L => L.id === UI.selLine) || null : null; };
